import { logStatsigEvent } from '@libs/feature-toggle';

import type { BaseMetadata } from '../../models';

// NOTE: This function exists to allow for mocking it in unit tests
export function logStatsigEventWrapper(
  eventName: string,
  eventValue?: string | number | undefined,
  eventMetadata?: Record<string, string> | undefined,
  baseMetadata?: BaseMetadata | undefined
): void {
  const metadata = eventMetadata
    ? { ...baseMetadata, ...eventMetadata }
    : baseMetadata;

  logStatsigEvent(eventName, eventValue, metadata);
}
